module.exports = __webpack_public_path__ + "static/media/person-petting-puppy-svgrepo-com.40761415.svg";